/**
 * 系統訊息的嚴重程度。
 */
export enum SystemMessageSeverity {
  SUCCESS = 'success',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error'
}
